export type { SchoolContentProps } from "./SchoolContent.type";
import SchoolContent from "./SchoolContent";
export default SchoolContent;
